import Api from './ApiWAService'

// Grupos de WhatsApp via Cloud API (Groups API da Meta).
// Máx. 8 participantes; entrada apenas pelo link de convite (regra da Meta).
export default {
    list() {
        return Api().get('whatsapp_groups');
    },
    sync() {
        return Api().post('whatsapp_groups/sync');
    },
    create({ subject, description }) {
        return Api().post('whatsapp_groups', { subject, description });
    },
    update(id, { subject, description }) {
        return Api().put(`whatsapp_groups/${id}`, { subject, description });
    },
    remove(id) {
        return Api().delete(`whatsapp_groups/${id}`);
    },
    resetInviteLink(id) {
        return Api().post(`whatsapp_groups/${id}/invite-link/reset`);
    },
    removeParticipants(id, users) {
        return Api().delete(`whatsapp_groups/${id}/participants`, { data: { users } });
    },
}
